import React from "react";
import { Layers } from "lucide-react";
import { CHAINS } from "@/lib/chains";
import ChainIcon from "@/components/ChainIcon";
import LiveTxFeed from "@/components/LiveTxFeed";

export default function LaunchingSoon() {
  return (
    <div
      data-testid="launching-soon-banner-overlay"
      className="fixed inset-0 z-50 flex flex-col items-center overflow-y-auto bg-[#08090C] px-6 py-10"
    >
      {/* laser grid backdrop */}
      <div
        className="pointer-events-none absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "linear-gradient(rgba(204,255,0,0.14) 1px, transparent 1px), linear-gradient(90deg, rgba(204,255,0,0.14) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div
        className="pointer-events-none absolute left-0 right-0 h-[2px] bg-neon neon-glow"
        style={{ animation: "scanline 3.5s linear infinite", top: 0 }}
      />

      <div className="relative z-10 flex w-full max-w-md flex-1 flex-col items-center justify-center text-center">
        {/* logo */}
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-neon/40 bg-neon/5 neon-glow float-y">
          <Layers className="h-8 w-8 text-neon" strokeWidth={1.7} />
        </div>
        <p className="font-rajdhani text-xs uppercase tracking-[0.55em] text-neon">CoreWallet</p>
        <h1 className="mt-4 font-outfit text-4xl font-extrabold leading-tight text-white sm:text-5xl">
          The Multi-Chain<br />Vault
        </h1>
        <p className="mt-4 max-w-sm font-sans text-sm leading-relaxed text-[#9CA3AF]">
          One non-custodial wallet securing six sovereign blockchains. Your keys,
          your coins.
        </p>

        {/* network grid */}
        <div className="mt-9 grid w-full grid-cols-3 gap-3">
          {CHAINS.map((c) => (
            <div
              key={c.id}
              className="flex flex-col items-center gap-2 rounded-2xl border border-[#1F2430] bg-[#12141A] p-3 block-pulse"
            >
              <ChainIcon chain={c} size={38} />
              <span className="font-outfit text-xs font-semibold text-white">{c.name}</span>
              <span className="flex items-center gap-1 font-rajdhani text-[10px] uppercase tracking-wider text-[#6B7280]">
                <span className="h-1.5 w-1.5 rounded-full pulse-glow" style={{ background: c.color }} />
                Ready
              </span>
            </div>
          ))}
        </div>

        {/* live on-chain transactions */}
        <div className="mt-8 w-full">
          <LiveTxFeed />
        </div>
        <p className="mt-4 font-rajdhani text-[11px] uppercase tracking-[0.3em] text-[#6B7280]">
          BIP-39 · BIP-44 · AES-256 · Zero-Knowledge
        </p>
      </div>

      {/* marquee ticker */}
      <div className="relative z-10 mt-8 w-full max-w-md overflow-hidden rounded-full border border-[#1F2430] bg-[#12141A]/70 py-2.5">
        <div className="marquee-track">
          {[...CHAINS, ...CHAINS].map((c, i) => (
            <span key={i} className="mx-5 inline-flex items-center gap-2 font-rajdhani text-sm font-semibold" style={{ color: c.color }}>
              <span className="h-2 w-2 rounded-full" style={{ background: c.color }} />
              {c.name}
              <span className="text-[#6B7280]">•</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
